// VibeProSoft AI consulting service packages (PRD §16).

export interface ServicePackage {
  id: string;
  name: string;
  duration: string;
  tagline: string;
  outputs: string[];
}

export const SERVICE_PACKAGES: ServicePackage[] = [
  {
    id: 'readiness_sprint',
    name: 'AI Readiness Sprint',
    duration: '1–2 weeks',
    tagline: 'Know exactly where you stand and what to do first.',
    outputs: ['Maturity scorecard', 'Prioritized opportunities', 'Readiness gaps', 'Next steps'],
  },
  {
    id: 'governance_foundation',
    name: 'AI Governance & Risk Foundation',
    duration: '2–4 weeks',
    tagline: 'NIST AI RMF-aligned policies, inventory, and risk management that scale.',
    outputs: ['AI policy starter pack', 'AI inventory', 'Risk register', 'NIST RMF mapping', 'Governance cadence'],
  },
  {
    id: 'automation_roadmap',
    name: 'AI Automation Opportunity Roadmap',
    duration: '2–3 weeks',
    tagline: 'A scored use-case portfolio and a roadmap your executives can fund.',
    outputs: ['Use-case portfolio', 'ROI estimates', 'Roadmap', 'Pilot plan'],
  },
  {
    id: 'engineering_architecture',
    name: 'AI Engineering & Agent Architecture',
    duration: '3–6 weeks',
    tagline: 'RAG, agents, MCP, and guardrails designed before you build.',
    outputs: ['Target architecture', 'RAG/agent design', 'MCP & tool governance', 'Implementation backlog'],
  },
  {
    id: 'ai_sdlc',
    name: 'AI-Enhanced Software Delivery',
    duration: '2–6 weeks',
    tagline: 'Ship faster with AI coding tools — without losing quality or control.',
    outputs: ['AI SDLC playbook', 'Developer productivity plan', 'Design-to-code workflow', 'Guardrails & metrics'],
  },
];

export const PACKAGE_IDS = SERVICE_PACKAGES.map((p) => p.id);

export function packageById(id: string | null | undefined): ServicePackage | undefined {
  return SERVICE_PACKAGES.find((p) => p.id === id);
}
